import React from "react"
import {styled} from "@cirrus/ui-kit/src/lib/_public"

const PercentageCellStyled = styled("div")({
  "&::before": {
    display: "block",
    content: ({ percentage }) => `" "`,
    position: "absolute",
    background: "rgba(0, 85, 176, 0.3)",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "right",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "2",
    paddingRight: "5px",
    fontWeight: "bold"
  },

  "&:after": {
    display: "block",
    content: ({ percentage }) => `"${Math.round(Number(percentage) * 100)}%"`,
    position: "absolute",
    background: ({ percentage }) =>
      Number(percentage) * 100 === 100 && "rgba(51, 159, 122, 1)"
      || Number(percentage) * 100 === 0 && "transparent"
      || "rgba(51, 119, 191, 1)",
    top: "0",
    left: "0",
    color: "#fff",
    fontSize: "12px",
    lineHeight: "20px",
    paddingLeft: "5px",
    width: ({ percentage }) => `${Number(percentage) * 100}%`,
    height: "100%",
    zIndex: "3",
    fontWeight: "bold"
  },

  "& > div": {
    fontSize: "12px",
    lineHeight: "20px",
    zIndex: 4,
    fontWeight: "bold",
    position: "absolute",
    right: "5px",
    top: 0
  },

  position: "relative",
  height: "20px",
  width: "100%"
})

const PercentageCellBorders = styled("div")({
  "&:before": {
    position: "absolute",
    content: "' '",
    display: "block",
    width: "1px",
    height: "100%",
    top: "0",
    left: "33.33%",
    background: "#ebebeb",
  },

  "&:after": {
    position: "absolute",
    content: "' '",
    display: "block",
    width: "1px",
    height: "100%",
    top: "0",
    left: "66.66%",
    background: "#ebebeb",
  },

  position: "absolute",
  top: "0",
  border: "1px solid #9B9B9B",
  borderTop: "none",
  borderBottom: "none",
  width: "calc(100% - 32px)",
  height: "100%",
})

export const PercentageProgressCell = (props: {percentage: string}) => {
  const leftPercentageValue = Math.round(100 - Number(props.percentage) * 100)

  return (
    <>
      <PercentageCellBorders />
      <PercentageCellStyled percentage={props.percentage}>
        {leftPercentageValue !== 0 ? <div>{`${leftPercentageValue}%`}</div> : null}
      </PercentageCellStyled>
    </>
  )
}